import * as z from "zod";
import { Role } from "@/types/user";
import {
  USER_POSITION_MAX_LENGTH,
  USER_POSITION_TOO_LONG_KEY,
} from "./userPosition";

export const userFormSchema = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string().email().optional(),
  phone: z.string().optional(),
  roleMode: z.enum(["system", "custom"]).optional(),
  role: z.enum(Role),
  customRoleId: z.string().optional(),

  photoId: z.string().optional(),
  hotelId: z.string().optional(),
  username: z.string().optional(),
  password: z.string().optional(),
  pin: z.string().optional(),
  preferredLanguage: z.string().optional(),
  position: z
    .string()
    .trim()
    .max(USER_POSITION_MAX_LENGTH, USER_POSITION_TOO_LONG_KEY)
    .optional(),
});

export type UserFormData = z.infer<typeof userFormSchema>;
